export function themeIdentifier(id) {
  return `THEME_${id}`;
}

export function pitchIdentifier(id) {
  return `PITCH_${id}`;
}



// WEBPACK FOOTER //
// ./library/app/utils/diagramIdentifierName.js